import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import ModalInvitados from './ModalInvitados';
import ModalInvitadosEmpresas from './ModalInvitadosEmpresas';
import Slide from '../Globals/Slide/slide'


const customStyles = {
  content : {
    top                   : '65%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%,-50%)',
	width                 : '450px'
	
  }
};

const database=firebase.database();

class InvitadosEmpresas extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			invitados:[],
			isActive:false
			
			
		}
		
		this.handleClick=this.handleClick.bind(this);
		this.toggleModal=this.toggleModal.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.invitadosRef=database.ref().child('Invitados').orderByChild('codigo_empresa').equalTo(firebase.auth().currentUser.uid);
	
		
	
	
	}
	
	componentDidMount(){
		
		this.invitadosRef.on('value',this.gotData,this.errData);
		
	}
	
	componentWillMount(){
		
		
	}
	
	gotData=(data)=>{
		
		
		let newInvitados=[]
		
		
		if(data.val()!==null){
			
			let invitado=data.val();
			let keys=Object.keys(invitado);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				newInvitados.push({
					key:k,
					apellido:invitado[k].apellido,
					codigo_empresa:invitado[k].codigo_empresa,
					contrasena:invitado[k].contrasena,
					correo:invitado[k].correo,
					dui:invitado[k].dui,					
					fecha_final:invitado[k].fecha_final,					
					fecha_inicio:invitado[k].fecha_inicio,					
					hora_final:invitado[k].hora_final,
					hora_inicio:invitado[k].hora_inicio,
					nombre:invitado[k].nombre,
					nombre_empresa:invitado[k].nombre_empresa,
					pasaporte:invitado[k].pasaporte
					

				})
				
			}
			this.setState({invitados:newInvitados})
			
			
			
			
		}
		
		
	}
	errData=(err)=>{
		
		console.log(err);
		
	}
	
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	handleClick(row){
	
	
		
		this.setState({
			
			invitadoKey:row.key,
			nombre:row.nombre,
			apellido:row.apellido,
			dui:row.dui,
			pasaporte:row.pasaporte,
			correo:row.correo,
			contrasena:row.contrasena,
			fecha_inicio:row.fecha_inicio,
			fecha_final:row.fecha_final,
			hora_inicio:row.hora_inicio,
			hora_final:row.hora_final
	
	
		})
		
		
		this.toggleModal();
	
	}
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
		})
				
	}
	
	handleSubmit(event){
		

		
		let nombre=this.nombre.value;
		let apellido=this.apellido.value;
		let dui=this.dui.value;
		let pasaporte=this.pasaporte.value;
		let correo=this.correo.value;
		let contrasena=this.password.value;
		let fecha_inicio=this.fecha_inicio.value;
		let fecha_final=this.fecha_final.value;
		let hora_inicio=this.hora_inicio.value;
		let hora_final=this.hora_final.value;
		
		
		
		database.ref().child('Invitados').child(this.state.invitadoKey).update({
				nombre:nombre,
				apellido:apellido,
				dui:dui,
				pasaporte:pasaporte,
				fecha_inicio:fecha_inicio,
				fecha_final:fecha_final,
				hora_inicio:hora_inicio,
				hora_final:hora_final
						
		})
		
		
		
		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
		});
		
		
		
		
	
	
		this.toggleModal();
	
		event.preventDefault();
	}
	
	
	
	render(){
		
		return(
			<div>
			<Slide/>
			<br/>
				<div className="invitados_empresas container">
					
						<h1 className="titulo">Invitados</h1>
						
						<ModalInvitadosEmpresas/>
						<BootstrapTable data={ this.state.invitados}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>						
							 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>						
							 <TableHeaderColumn dataField='correo' dataSort={true}  >Correo</TableHeaderColumn>						
							 <TableHeaderColumn dataField='pasaporte' dataSort={true}  >Pasaporte</TableHeaderColumn>						
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>

						</BootstrapTable>
						
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >				
					
							<h3>Agregar invitados</h3>
							
							<hr/>
					
							<form method="POST" action="" onSubmit={this.handleSubmit}>
								<div className="form-group">
									<label htmlFor="nombre" >Nombre</label>
									<input type="text" name="nombre"  placeholder="Nombre" className="form-control"
									required autoComplete="off" 
									ref={input=>{this.nombre=input;}}
									defaultValue={this.state.nombre}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="apellido">Apellido</label>
									<input type="text" name="apellido" className="form-control" placeholder="Apellido"
									required autoComplete="off" 
									ref={input=>{this.apellido=input;}}
									defaultValue={this.state.apellido}
									/>
								</div>
								<div className="form-group">
								    <label htmlFor="dui">Dui</label>
									<input type="text" name="dui" className="form-control" placeholder="Dui"
									maxLength="10" minLength="10"
									required autoComplete="off" 
									ref={input=>{this.dui=input;}}
									defaultValue={this.state.dui}									
									/>								
								</div>
								<div className="form-group">
									<label htmlFor="correo">Correo</label>
									<input type="email" name="correo" className="form-control" placeholder="Correo"
									required autoComplete="off" 
									ref={input=>{this.correo=input;}}
									defaultValue={this.state.correo}
									disabled="disabled"
									/>
								</div>
										
								<div className="form-group">
									<label htmlFor="Contraseña">Contraseña</label>
									<input type="text" name="contrasena" className="form-control" placeholder="Contraseña" 
									required autoComplete="off" 
									ref={input=>{this.password=input;}}
									defaultValue={this.state.contrasena}
									disabled="disabled"
									/>
								</div>
								
								<div className="form-group">
										<label>Fecha inicio</label>
										<input type="date" name="fecha_inicio"  required autoComplete="off"
										defaultValue={this.state.fecha_inicio} className="form-control"
										ref={input=>{this.fecha_inicio=input;}}
										/>
								</div>
								<div className="form-group">
										<label>Fecha fin</label>
										<input type="date" name="fecha_final"  required autoComplete="off"
										defaultValue={this.state.fecha_final} className="form-control"
										ref={input=>{this.fecha_final=input;}}
										/>
								</div>
								<div className="form-group">
										<label>Hora inicio</label>
										<input type="time" name="fecha"  required autoComplete="off"
										defaultValue={this.state.hora_inicio} className="form-control"
										ref={input=>{this.hora_inicio=input;}}
										/>
								</div>
								<div className="form-group">
										<label>Hora fin</label>
										<input type="time" name="fecha"  required autoComplete="off"
										defaultValue={this.state.hora_final} className="form-control"
										ref={input=>{this.hora_final=input;}}
										/>
								</div>
						
								<div className="form-group">
									<label htmlFor="pasaporte">Pasaporte</label>
									<input type="text"  name="pasaporte" className="form-control" placeholder="Pasaporte"
									required autoComplete="off" 
										ref={input=>{this.pasaporte=input;}}
										defaultValue={this.state.pasaporte}
									/>
								</div>
								
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>

			
				
				</div>
				</div>
				
				
		
		);
		
		
		
	}
	
	
	
}

export default InvitadosEmpresas;


// WEBPACK FOOTER //
// ./src/Components/Invitados/InvitadosEmpresas.js